var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"graphArea",staticClass:"w-full h-full overflow-hidden"})
}
var staticRenderFns = []

export { render, staticRenderFns }